import React, { FC, useState } from 'react'
import { ContentfulRichText } from '@/atoms/ContentfulRichText'
import { FlexColumn } from '@/atoms/FlexContainers'
import { PlayIcon } from '@/atoms/Icons/PlayIcon'
import { Image } from '@/atoms/Image'
import { EmbeddedVideo } from '@/molecules/EmbeddedVideo'
import { GiveawayDetailsTabText, GiveawayPartnerLogo, Maybe } from '@/types/codegen-contentful'
import { useSafeAnalytics } from '@/utils/analytics'
import { giveawayRichTextOverrides } from '../../../utils/richtextUtils'
import { GalleryCarousel } from './GalleryCarousel'

interface Props {
  galleryImages?: Maybe<GiveawayPartnerLogo>[]
  trailerId: string | null | undefined
  text?: Maybe<GiveawayDetailsTabText>
  videoThumbnail?: Maybe<string>
}

export const PresaleDetailsTab: FC<Props> = ({ galleryImages, trailerId, videoThumbnail, text }) => {
  const [loadPlayer, setLoadPlayer] = useState(!videoThumbnail)
  const { track } = useSafeAnalytics()

  return (
    <FlexColumn className="mb-16 w-full gap-16 px-4 pt-16 md:gap-[72px] md:px-9 md:pb-32">
      <div className="flex w-full flex-col gap-1">
        {trailerId && (
          <div
            id="youtube"
            style={{ aspectRatio: 16 / 9 }}
            className="relative my-3 w-full max-w-[361px] overflow-hidden rounded-[10px] md:mb-[72px] md:max-w-[530px]"
          >
            {!loadPlayer && videoThumbnail && (
              <div
                className="cursor-pointer"
                onClick={() => {
                  track('Giveaway Video Clicked')
                  setLoadPlayer(true)
                }}
              >
                <Image
                  alt="Video player thumbnail"
                  src={videoThumbnail}
                  quality={100}
                  fill
                  className="object-cover object-center"
                />
                <div className="absolute left-1/2 top-1/2 flex h-fit w-fit -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-white p-4">
                  <PlayIcon size={32} color="core-gray-950" />
                </div>
              </div>
            )}
            {loadPlayer && (
              <EmbeddedVideo
                url={`https://www.youtube-nocookie.com/embed/${trailerId}?autoplay=1`}
                className="mx-auto !rounded-[10px] md:mx-0"
              />
            )}
          </div>
        )}

        {text && <ContentfulRichText {...text} renderOptionOverrides={giveawayRichTextOverrides} />}
      </div>

      {!!galleryImages?.length && <GalleryCarousel galleryImages={galleryImages} />}
    </FlexColumn>
  )
}
